module.exports = __webpack_public_path__ + "img/tpc-web-6.70047bb9.jpg";